import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'codigoTupa'
})
export class CodigoTupaPipe implements PipeTransform {

  transform(arr: string): any {
    if (arr) {
      return arr.split('-')[1];
    }
    return null;
  }

}
